/**
* Featured Treatments JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Treatments component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'featured-treatments',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // Select the top button and all toggle buttons
      const selectedButton = document.getElementById( 'selected-button' );
      const toggleButtons = document.querySelectorAll( '.featured-treatments__toggle' );

      // Initially store the chevron icon and text
      const initialChevron = selectedButton.querySelector( 'svg' );
      const initialText = selectedButton.textContent.trim();

      // Add event listeners to toggle buttons
      toggleButtons.forEach( ( button ) => {
        button.addEventListener( 'click', () => {
          const category = button.getAttribute( 'data-category' ); // Get the category from the button
          if ( category ) {
            selectedButton.innerHTML = `${category} `; // Update the text content
            selectedButton.appendChild( initialChevron ); // Re-append the chevron icon
          }
        } );
      } );

      // Optionally, ensure the initial value reflects the first button's category if it hasn't been updated yet
      const defaultActiveButton = document.querySelector( '[data-toggle-is-active]' );
      if ( defaultActiveButton && selectedButton.textContent.trim() === initialText ) {
        selectedButton.innerHTML = `${defaultActiveButton.getAttribute( 'data-category' )} `;
        selectedButton.appendChild( initialChevron ); // Re-append the chevron to the updated text
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-treatments', COMPONENT );
} )( app );
